import { Pipe, PipeTransform } from '@angular/core';

/**
 * NEO-4044 (D019): labels a value whose leave type has since been archived.
 *
 * An archived type stays in its dropdown so a record that already stores it still renders — it is
 * disabled rather than removed (D020). This marks it, so "listed but not selectable" is self-evident
 * instead of looking like an ordinary choice the user simply cannot click.
 *
 * Deliberately one shared pipe rather than a ternary repeated per template: four dropdowns render
 * this today and mobile renders the same concept, so the wording needs a single home. It is also why
 * the suffix is composed in the CLIENT — the CSV export resolves its label from the same option list
 * server-side (`TimesheetService.GetFormattedValue`), and that column must stay machine-readable.
 */
// Same wording as Neo.Link's LeaveTypeDropdownOptions.ArchivedMarker.
const ARCHIVED_MARKER = '(Archived)';

@Pipe({
    name: 'archivedLabel',
    // Standalone: consumed both by module-declared templates (via SharedModule) and directly by
    // standalone components (the two bulk-update dialogs and the leave-request dialog).
    standalone: true
})
export class ArchivedLabelPipe implements PipeTransform {

  public transform = (label: string | null | undefined, isArchived?: boolean | null): string => {
    const text = label ?? '';
    // NEO-3799: per-record lists arrive already marked by the server — never mark twice.
    if (isArchived !== true || text === '' || text.endsWith(ARCHIVED_MARKER)) return text;
    return `${text} ${ARCHIVED_MARKER}`;
  }
}
